// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'



// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';

import 'jquery-hoverintent';
import 'balance-text';
import 'theia-sticky-sidebar';
import 'masonry-layout/dist/masonry.pkgd.min.js';
import 'waypoints/lib/jquery.waypoints.js';


    
// import then needed Font Awesome functionality
import { library, dom } from '../../../vendor/fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
import { faFacebook, faTwitter, faLinkedin, faInstagram, faYoutube } from '../../../vendor/fortawesome/free-brands-svg-icons';
import { faPhone, faEnvelope, faExternalLinkAlt, faSearch, faAngleRight } from '../../../vendor/fortawesome/free-solid-svg-icons';
// add the imported icons to the library
library.add(faYoutube, faFacebook, faTwitter, faLinkedin, faInstagram, faPhone, faEnvelope, faExternalLinkAlt, faSearch, faAngleRight);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js